import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import './App.css';
import './Make.css';

import Chan02 from './Chan02.png';
import Chan05 from './Chan05.png';
import Chan06 from './Chan06.png';

function Make(props) {

  const [newAcc, setNewAcc] = useState(`未作成`);
  const [newPubKey, setNewPubKey] = useState(`未取得`);
  const [newSecKey, setNewSecKey] = useState(`未取得`);

  const [t, i18n] = useTranslation();







  const submit = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='CC'>
            <h1>*{t('本当に作る？')}</h1>
            <p>{t('あなたはアカウントを持っていませんね？')}</p>
            <button onClick={onClose}>{t('いいえ')}</button>
            <button
              onClick={() => {
                handleClick();
                onClose();
              }}
            >
              {t('はい')}
            </button>
          </div>
        );
      }
    });
  };

  const handleClick = () => {

    const IOST = require('@kunroku/iost');

    // init iost sdk (default is for localhost network)
    const iost = new IOST({
      host: 'https://api.iost.io',
      chainId: 1024,
      gasLimit: 1000000
    });

    const creatorId = "aiyaa_cs";
    const secretKey = process.env.REACT_APP_DEV_API_KEY;

    const account = new IOST.Account(creatorId);
    const kp = new IOST.KeyPair.Ed25519(IOST.Bs58.decode(secretKey));

    account.addKeyPair('active', kp);
    account.addKeyPair('owner', kp);

    const rndm = ("0000000" + Math.floor(Math.random() * 10000000)).slice(-5);
    const newId = 'chan_' + rndm;
    // const newId = 'aiyaa';
    const newKp = IOST.KeyPair.Ed25519.randomKeyPair();
    // show secret key of new account

    console.log(newId);
    console.log(IOST.Bs58.encode(newKp.secretKey));

    const tx = iost.contract.auth.signUp(newId, IOST.Bs58.encode(newKp.publicKey), IOST.Bs58.encode(newKp.publicKey));
    // iGasの初期設定（今はこれで30IOSTを渡している）
    iost.contract.gas.pledge(creatorId, newId, 1, tx);
    // iRamの初期設定（今はこれで3.4IOSTを渡している）
    iost.contract.ram.buy(creatorId, newId, 1024, tx);

    iost.setPublisher(account);

    const handler = iost.signAndSend(tx);

    setNewAcc(`作成中です…`);

    handler.listen();

    handler
      .onPending(function (txid) {
        console.log("トランザクションID: " + JSON.stringify(txid));
      })
      .onSuccess(function (result) {
        console.log("送金結果: " + JSON.stringify(result));
      })
      .onFailed(function (failed) {
        // 仮に画面上はおかしくても、アラートを出して知らせる。。
        alert("画面上は成功していますが、アカウント作成に失敗しています。再度お試しください。");
        console.log("送金失敗: " + JSON.stringify(failed));
        newAcc(`作成失敗`);
      });
    // とりあえず成功した前提で値は取得する。
    handler.onSuccess(
      setNewAcc(newId),
      setNewPubKey(IOST.Bs58.encode(newKp.publicKey)),
      setNewSecKey(IOST.Bs58.encode(newKp.secretKey))
    );
  }



  const copyNewKey = () => {

    if (newSecKey == "未取得") {

      switch (props.lng) {
        case 'ja':
          alert(`まだアカウントが作成出来ていません！`);
          break;
        case 'en':
          alert(`Your account is not here yet!`);
          break;
        case 'cn':
          alert(`你还没有一个账户!`);
          break;
      }

    } else if (newSecKey == "失敗") {
      switch (props.lng) {
        case 'ja':
          alert(`アカウント作成に失敗しています！`);
          break;
        case 'en':
          alert(`Account creation failed!`);
          break;
        case 'cn':
          alert(`您的账户创建失败!`);
          break;
      }
    } else {
      navigator.clipboard.writeText(newSecKey);

      switch (props.lng) {
        case 'ja':
          alert(`秘密鍵をコピーしました！必ず保管してください！`);
          break;
        case 'en':
          alert(`You've copied the private key! Make sure you keep it!`);
          break;
        case 'cn':
          alert(`你已经复制了你的私钥! 请确保你保留它!`);
          break;
      }
    }

  }

  const dlAccountInfo = () => {
    if (newSecKey == "未取得") {
      switch (props.lng) {
        case 'ja':
          alert(`まだアカウントが作成出来ていません！`);
          break;
        case 'en':
          alert(`Your account is not here yet!`);
          break;
        case 'cn':
          alert(`你还没有一个账户!`);
          break;
      }
    } else if (newSecKey == "失敗") {
      switch (props.lng) {
        case 'ja':
          alert(`アカウント作成に失敗しています！`);
          break;
        case 'en':
          alert(`Account creation failed!`);
          break;
        case 'cn':
          alert(`您的账户创建失败!`);
          break;
      }
    } else {
      let fileName;
      let content;

      switch (props.lng) {
        case 'ja':
          fileName = "アカウント情報（" + newAcc + "）.txt";
          content = "【あなたのアカウント名】" + newAcc + "\n\【あたなの公開鍵】" + newPubKey + "\n\【あなたの秘密鍵】" + newSecKey;
          break;
        case 'en':
          fileName = "Account information (" + newAcc + "）.txt";
          content = " [Your account name]" + newAcc + "\n\ [Your public key]" + newPubKey + "\n\ [Your private key]" + newSecKey;
          break;
        case 'cn':
          fileName = "帐户信息 (" + newAcc + "）.txt";
          content = "　您的账户名称：" + newAcc + "\n\　你的公钥：" + newPubKey + "\n\　你的私钥：" + newSecKey;
          break;
      }

      const BLOB = new Blob([content], { 'type': 'text/plain' });
      const CAN_USE_SAVE_BLOB = window.navigator.msSaveBlob !== undefined;

      if (CAN_USE_SAVE_BLOB) {
        window.navigator.msSaveBlob(BLOB, fileName);
        return;
      }

      const TEMP_ANCHOR = document.createElement('a');
      TEMP_ANCHOR.href = URL.createObjectURL(BLOB);
      TEMP_ANCHOR.setAttribute('download', fileName);

      TEMP_ANCHOR.dispatchEvent(new MouseEvent('click'));
    }
  }

  let chanimg;
  if (newSecKey == "未取得") {
    chanimg = <img src={Chan02} alt="作ってます！" />;
  } else if (newSecKey == "失敗") {
    chanimg = <img src={Chan05} alt="無理だったわ" />;
  } else {
    chanimg = <img src={Chan06} alt="できたよ！" />;
  }

  let account;
  if (newAcc == "未作成") {
    account = <span>{t('未作成')}</span>;
  } else if (newAcc == "作成失敗") {
    account = <span>{t('作成失敗')}</span>;
  } else {
    account = <span>{t('作成成功')}</span>;
  }


  return (
    <div className="Make">
      <div className="PgName">🍭{t('アカウントをつくる')}</div>

      <button className="Make" onClick={submit}>🍭<br />{t('つくる')}</button>

      <button className="Back" onClick={() => props.pg(`menu`)}>{t('もどる')}</button>

      <div className="MakeImg">
        {chanimg}
      </div>

      <div className="MakeRes">
        <p>
          <span>{t('あなたのアカウントは')}</span><br></br>
          <span className="Account">{account}</span><br></br>
          <span className="Alert">
            ⚠{t('秘密鍵は必ず保存してください！')}<br></br>
            ⚠{t('絶対に他人に教えないでください！')}
          </span>
        </p>
      </div>
      <button className="Menu" onClick={copyNewKey}>📎{t('秘密鍵をコピー')}</button>
      <button className="Menu" onClick={dlAccountInfo}>📥{t('まとめてダウンロード')}</button>
    </div>
  );
}

export default Make;